import { HSAApi, HSAUnit } from "../../../generated/api";
import { getAPIConfig } from "../../../util/api-config";
import { handleError } from "../../../util/errorHandler";
import store from "../../configureStore";
import {
  setCareProviders,
  setCareUnits,
  setLastImport,
} from "../../reducers/hsaReducer";
import { put } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import { setLoading } from "../../reducers/loadingReducer";
import i18n from "../../../i18n/i18n";

function setUpClient() {
  return new HSAApi(getAPIConfig(store.getState().settings.internalSettings));
}

export function* handleGetLastSuccessfulImport(): any {
  try {
    const HSAClient = setUpClient();
    const response = yield HSAClient.getLastSuccessfulImport();
    yield put(setLastImport(response));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleImportHSAUnits(): any {
  try {
    const HSAClient = setUpClient();
    yield put(setLoading(true));
    yield HSAClient.saveHsaUnits();
    toast.success(String(i18n.t("toasts.importDone")));
    yield put({ type: "GET_LATEST_SUCCESSFUL_HSA_IMPORT" });
  } catch (error: any) {
    yield handleError(error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* handleSearchHSAUnits(action: any): any {
  try {
    const HSAClient = setUpClient();
    const searchString = action.searchString;
    yield put(setLoading(true));
    const response = yield HSAClient.searchHsaUnits(searchString);

    const careProviders: HSAUnit[] = [];
    const careUnits: HSAUnit[] = [];

    response.forEach((hsaUnit: HSAUnit) => {
      if (hsaUnit.isCareProvider) {
        careProviders.push(hsaUnit);
      }
      if (hsaUnit.isCareUnit) {
        careUnits.push(hsaUnit);
      }
    });
    yield put(setCareProviders(careProviders));
    yield put(setCareUnits(careUnits));
  } catch (error: any) {
    if (error?.status === 504) {
      toast.error(String(i18n.t("errors.hsaTimeOut")));
    } else {
      yield handleError(error);
    }
  } finally {
    yield put(setLoading(false));
  }
}
